import React, { Component } from 'react';
import Dropdown from 'react-toolbox/lib/dropdown';
/* The paginate component used https://github.com/AdeleD/react-paginate */
import ReactPaginate from 'react-paginate';
import _debug from 'debug';

import styles from './Pagination.css';

const debug = _debug('app:Pagination');
const pages = [
  { value: 1, label: '50' },
  { value: 2, label: '100' },
  { value: 3, label: '250' },
  { value: 4, label: '500' }
];

export default class Pagination extends Component {

  static propTypes = {
    updateUnassignedStartEndIndex: React.PropTypes.func,
    updateAssignedStartEndIndex: React.PropTypes.func,
    tabIndex: React.PropTypes.number,
    tabOneDropdownValue: React.PropTypes.string,
    tabTwoDropdownValue: React.PropTypes.string,
    selectedRecordsCount: React.PropTypes.number,
    recordCount: React.PropTypes.number,
    unassignedStartIndex: React.PropTypes.number,
    unassignedEndIndex: React.PropTypes.number,
    assignedStartIndex: React.PropTypes.number,
    assignedEndIndex: React.PropTypes.number,
    updateInspectedStartEndIndex: React.PropTypes.func,
    tabThreeDropdownValue: React.PropTypes.string,
    inspectedStartIndex: React.PropTypes.number,
    strings: React.PropTypes.shape({}),
    inspectedEndIndex: React.PropTypes.number,
    searchActivePage: React.PropTypes.bool,
    updateActivePage: React.PropTypes.func,
  }

  constructor(props) {
    super(props);
    this.state = {
      activePageUnassigned: 0,
      activePageAssigned: 0,
      activePageInspected: 0
    };
  }

  handleChange = (value) => {
    if (this.props.tabIndex === 0) {
      this.props.updateUnassignedStartEndIndex(
        0,
        parseInt(pages.filter(obj => obj.value === value)[0].label, 10)
      );
    } else if (this.props.tabIndex === 1) {
      this.props.updateAssignedStartEndIndex(
        0,
        parseInt(pages.filter(obj => obj.value === value)[0].label, 10)
      );
    } else if (this.props.tabIndex === 2) {
      this.props.updateInspectedStartEndIndex(
        0,
        parseInt(pages.filter(obj => obj.value === value)[0].label, 10)
      );
    }

    if (this.props.tabIndex === 0) {
      this.setState({ activePageUnassigned: 0 });
    } else if (this.props.tabIndex === 1) {
      this.setState({ activePageAssigned: 0 });
    } else if (this.props.tabIndex === 2) {
      this.setState({ activePageInspected: 0 });
    }
  };

  activePage = () => {
    debug('Active Page Unassigned Calling', this.state.activePageUnassigned);
    debug('Active Page Assigned Calling', this.state.activePageAssigned);
    return this.activePageCount(this.props.tabIndex);
  }

  handlePageClick = (data) => {
    this.props.updateActivePage(false);
    debug('the values of ', this.props.tabOneDropdownValue, this.props.tabTwoDropdownValue);
    debug('The page click values ', data.selected);
    if (this.props.tabIndex === 0) {
      this.setState({ activePageUnassigned: data.selected });
    } else if (this.props.tabIndex === 1) {
      this.setState({ activePageAssigned: data.selected });
    } else if (this.props.tabIndex === 2) {
      this.setState({ activePageInspected: data.selected });
    }
    const tabValue = this.recordCount(this.props.tabIndex);
    const value = pages.filter(obj => obj.label === tabValue)[0].value;
    const rowsCount = pages.filter(obj => obj.value === value)[0].label;
    const endIndex = parseInt(rowsCount * (data.selected + 1), 10);
    const startIndex = parseInt(endIndex - rowsCount, 10);
    if (this.props.tabIndex === 0) {
      this.props.updateUnassignedStartEndIndex(
        startIndex,
        endIndex
      );
    } else if (this.props.tabIndex === 1) {
      this.props.updateAssignedStartEndIndex(
        startIndex,
        endIndex
      );
    } else if (this.props.tabIndex === 2) {
      this.props.updateInspectedStartEndIndex(
        startIndex,
        endIndex
      );
    }
  };

  startEndIndexCalc = () => {
    const { strings } = this.props;
    let endIndex = this.endIndexCount(this.props.tabIndex);
    if ((this.state.activePageUnassigned !== 0 && this.props.searchActivePage) ||
      (this.state.activePageAssigned !== 0 && this.props.searchActivePage)) {
      if (this.props.recordCount > 50) {
        endIndex = 50;
        if (this.props.tabIndex === 0) {
          this.props.updateUnassignedStartEndIndex(
            0,
            50
          );
        } else if (this.props.tabIndex === 1) {
          this.props.updateAssignedStartEndIndex(
            0,
            50
          );
        }
      } else if (this.props.tabIndex === 2) {
        endIndex = (endIndex > this.props.recordCount) ? this.props.recordCount : endIndex;
      } else {
        endIndex = (endIndex > this.props.recordCount) ? this.props.recordCount : endIndex;
      }
    } else {
      endIndex = (endIndex > this.props.recordCount) ? this.props.recordCount : endIndex;
    }
    return endIndex > 50 ? `${strings.showing} ${(this.startIndexCount(this.props.tabIndex)) + 1} - ${endIndex} ${strings.of} ${this.props.recordCount}` : `${strings.showing}  1 - ${endIndex} ${strings.of} ${this.props.recordCount}`;
  };

  activePageCount = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return this.props.searchActivePage ? 0 : this.state.activePageUnassigned;
      case 1:
        return this.props.searchActivePage ? 0 : this.state.activePageAssigned;
      case 2:
        return this.props.searchActivePage ? 0 : this.state.activePageInspected;
      default:
        return 0;
    }
  };

  recordCount = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return this.props.tabOneDropdownValue;
      case 1:
        return this.props.tabTwoDropdownValue;
      case 2:
        return this.props.tabThreeDropdownValue;
      default:
        return 0;
    }
  };

  endIndexCount = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return this.props.unassignedEndIndex;
      case 1:
        return this.props.assignedEndIndex;
      case 2:
        return this.props.inspectedEndIndex;
      default:
        return 0;
    }
  };

  startIndexCount = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return this.props.unassignedStartIndex;
      case 1:
        return this.props.assignedStartIndex;
      case 2:
        return this.props.inspectedStartIndex;
      default:
        return 0;
    }
  };


  dropdownValueCount = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return pages.filter(obj => obj.label === this.props.tabOneDropdownValue)[0].value;
      case 1:
        return pages.filter(obj => obj.label === this.props.tabTwoDropdownValue)[0].value;
      case 2:
        return pages.filter(obj => obj.label === this.props.tabThreeDropdownValue)[0].value;
      default:
        return 0;
    }
  }
  render() {
    const { strings } = this.props;
    return (
      <div
        className={styles.paginationContainer}
      >
        <div
          className={styles.selectorContainer}
        >
          <div className={styles.pageDropDown}>
            <Dropdown
              auto
              onChange={this.handleChange}
              source={pages}
              value={this.dropdownValueCount(this.props.tabIndex)}
              theme={styles}
            />
          </div>
        </div>
        <div className={styles.showingText}>
          {this.startEndIndexCalc()}
        </div>
        <div className={styles.showingText}>
          {this.props.selectedRecordsCount > 0 &&
            `${this.props.selectedRecordsCount} ${this.props.selectedRecordsCount > 1 ? strings.records : strings.record} ${strings.selected}`}
        </div>
        <div className={styles.pageNumberContainer} >
          <ReactPaginate
            previousLabel={''}
            nextLabel={'>'}
            pageNum={this.props.recordCount / this.recordCount(this.props.tabIndex)}
            initialSelected={this.activePage()}
            forceSelected={this.activePage()}
            breakLabel={'...'}
            breakClassName={styles.breakName}
            pageCount={this.recordCount(this.props.tabIndex)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            clickCallback={this.handlePageClick}
            containerClassName={this.props.tabIndex === 2 ?
              styles.reactInspectPaginateContainer : styles.reactPaginateContainer}
            subContainerClassName={styles.subPagination}
            activeClassName={styles.activePage}
            pageLinkClassName={styles.anchor}
            disabledClassName={styles.disabled}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Pagination/Pagination.js